<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>格子概率配置</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload ref="upload" class="upload-demo" :action="sys_app_logoAction" accept="xlsx" :limit="1" :on-success="(res)=>{return importUploadSuccess(res)}" :headers="headers">
                <el-button :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>
            <el-col :span="1.5">
              <el-button type="primary" icon="el-icon-download" size="mini" @click="exportData()">导出</el-button>
            </el-col>
            <el-col :span="1.5">
              <ClearCacheApply />
              <sync-data />
            </el-col>
          </el-row>
        </div>

        <el-table style="border:1px solid #ccc" :data="formData" border stripe>
          <el-table-column prop="id" label="格子ID">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.id" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.name" />
            </template>
          </el-table-column>
          <el-table-column prop="type" label="方块类型">
            <template v-slot:default="scope">
              <el-select v-model="scope.row.type" style="width: 100px">
                <el-option v-for="option in blockTypeOptions" :key="option.value" :label="option.label" :value="option.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot:default="scope">
              <el-button type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-button style="margin-top: 10px" type="primary" @click="add()">+</el-button>
        <el-button style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { getGridList, updateGrid, delGrid, exportGrid, importGrid } from '@/api/config/tetris/grid'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'TetrisGrid',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
      },
      blockTypeOptions: [
        { label: '普通', value: 1 },
        { label: '特殊', value: 2 },
        { label: '活动', value: 3 }
      ],
      formData: [
        {
          'id': 1,
          'name': '',
          'type': 1
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    validatePositive(row, field) {
      const value = parseFloat(row[field])
      if (isNaN(value) || value <= 0) {
        row[field] = 0
      }
    },
    onSubmit() {
      for (const item of this.formData) {
        const idNum = parseFloat(item.id)
        if (isNaN(idNum) || idNum <= 0) {
          this.msgError('格子ID必须大于0')
          return
        }
        if (!item.name || item.name.trim() === '') {
          this.msgError('名字不能为空')
          return
        }
        if (!item.type || item.type <= 0) {
          this.msgError('方块类型必须大于0')
          return
        }
      }
      const data = JSON.stringify(this.formData)
      updateGrid({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getGridList().then(res => {
        this.formData = res.data || []
      })
    },
    add() {
      const maxId = this.formData.length > 0 ? Math.max(...this.formData.map(item => item.id)) : 0
      this.formData.push({
        'id': maxId + 1,
        'name': '',
        'type': 1
      })
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delGrid({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importGrid({ data: response.data.path }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportGrid().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
